import { useSyncExternalStore } from "react";
import { getSnapshot, subscribe } from "@/lib/store";

export function useAppData() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useDomains() {
  const { domains } = useAppData();
  return { domains };
}

export function useSettings() {
  const { settings } = useAppData();
  return { settings };
}
